import { Link } from 'react-router-dom';
import type { CultureItem } from '@/types/content';
import { formatDate } from '@/lib/content';

export default function CultureCard({ item }: { item: CultureItem }) {
  return (
    <article className="group h-full flex flex-col rounded-lg border border-background-200/80 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors">
      <Link to={`/detail/culture/${item.id}`} className="block cursor-pointer">
        <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 琉璃神社文化专题`}
            className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
          />
          <span className="absolute left-4 top-4 px-2.5 py-1 rounded bg-primary-900/80 text-background-50 text-[11px] leading-none backdrop-blur-sm">
            文化专题
          </span>
        </div>
      </Link>
      <div className="flex flex-col flex-1 p-5 md:p-6">
        <div className="flex items-center gap-2 text-[11px] text-secondary-500 font-label">
          <span>{formatDate(item.date)}</span>
          <span className="w-1 h-1 rounded-full bg-background-400"></span>
          <span>{item.readTime}</span>
          <span className="w-1 h-1 rounded-full bg-background-400"></span>
          <span className="truncate">{item.author}</span>
        </div>
        <h3 className="mt-2.5 text-base md:text-lg font-semibold leading-7">
          <Link
            to={`/detail/culture/${item.id}`}
            className="hover:text-primary-700 transition-colors cursor-pointer"
          >
            {item.title}
          </Link>
        </h3>
        <p className="mt-1 text-xs text-accent-700 tracking-wide">{item.subtitle}</p>
        <p className="mt-2.5 text-sm text-secondary-600 leading-6 clamp-3">{item.summary}</p>
        <div className="mt-4 pt-3 border-t border-background-200/70 flex items-center justify-between">
          <div className="flex flex-wrap gap-1.5">
            {item.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 rounded bg-secondary-100 text-[11px] text-secondary-700 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
          <Link
            to={`/detail/culture/${item.id}`}
            className="text-xs text-primary-600 hover:text-accent-600 transition-colors inline-flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            阅读专题
            <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}